import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../services/api";
import HeroSection from "../components/home/HeroSection";
import ProgramsPreview from "../components/home/ProgramsPreview";
import WhyDVX from "../components/home/WhyDVX";
import TransformationsPreview from "../components/home/TransformationsPreview";
import TestimonialsPreview from "../components/home/TestimonialsPreview";
import VideoSection from "../components/home/VideoSection";
import CTASection from "../components/home/CTASection";
import PlansPreview from "../components/home/PlansPreview";
import SystemSection from "../components/home/SystemSection";
import FAQ from "../components/home/Faq";
import Contact from "./Contact";

export default function Home() {
  const [homeData, setHomeData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { hash } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    let isMounted = true;
    api
      .get("/home")
      .then((res) => {
        if (isMounted) setHomeData(res.data || null);
      })
      .catch((err) => console.error("Error fetching home data:", err))
      .finally(() => {
        if (isMounted) setLoading(false);
      });
    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    if (!hash || loading || !homeData) return;
    const targetId = hash.replace("#", "");
    if (!targetId) return;
    const target = document.getElementById(targetId);
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
      return;
    }
    const fallbackRoutes = {
      home: "/",
      about: "/about",
      testimonials: "/testimonials",
      transformations: "/transformations",
      pricing: "/pricing",
      faq: "/faq",
      contact: "/contact",
    };
    const fallback = fallbackRoutes[targetId];
    if (fallback && fallback !== "/") {
      navigate(fallback);
    }
  }, [hash, loading, homeData, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen bg-[var(--dvx-bg)] flex items-center justify-center transition-colors duration-300">
        <div className="font-oswald text-2xl text-[var(--dvx-text)] uppercase tracking-widest animate-pulse">
          Loading...
        </div>
      </div>
    );
  }

  if (!homeData) return null;

  return (
    <div data-testid="home-page">
      <HeroSection
        hero={homeData.hero}
        heroFeatures={homeData.hero_features}
        heroStats={homeData.hero_stats}
        heroBullets={homeData.hero_bullets}
      />
      <TestimonialsPreview
        section={homeData.testimonials_section}
        testimonials={homeData.testimonials}
      />
      <VideoSection section={homeData.video_hero} videos={homeData.videos} />
      <PlansPreview section={homeData.plans_section} plans={homeData.plans} />
      <TransformationsPreview
        section={homeData.transformations_section}
        transformations={homeData.transformations}
      />
      <SystemSection />
      {/* <ProgramsPreview
        section={homeData.programs_section}
        programs={homeData.programs}
      /> */}
      <WhyDVX section={homeData.why_dvx} />
      <FAQ />
      <Contact />
      <CTASection cta={homeData.cta} />
    </div>
  );
}
